import { render, staticRenderFns } from "./PassFailIcon.vue?vue&type=template&id=7356043a&"
import script from "./PassFailIcon.vue?vue&type=script&lang=js&"
export * from "./PassFailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports